export const hirschragout = {
	name: 'Hirschragout mit Birnestücken in Johannisbeer-Rotweinsauce',
	desc: 'dazu Kartoffelklöße, knackiger Eisbergsalat, Essig-Öl Dressing und dazu das Tagesdessert Joghurt im Becher',
	image: 11,
	opinions: [
		{
			name: 'Corinna Curry',
			date: '7. Fabruar 2017',
			title: 'Super lecker',
			content: 'Ich hätte nicht gedacht, dass man sowas leckeres in der Mensa bekommt. Wirklich würzig und sogar etwas weihnachtlich.',
			rating: 5,
		},
	],
	warnings: ['fleischAllgemein', 'alkohol', 'zucker', 'senf'],
	ingredients: [
		{'Hirschfleisch': 'fleischAllgemein'},
		{'Rotwein': 'alkohol'},
		'Zwiebeln',
		'Johannisbeeren',
		'Lorbeerblätter',
		{'Senfkörner': 'senf'},
		'Pfeffer',
		'Piment',
		'Petersilienwurzeln',
		'Karotten',
		{'Knollensellerie': 'Sellerie'},
		{'Butterschmalz': 'laktose'},
		{'Zucker': 'zucker'},
		{'Weizenmehl': 'weizen, gluten'},
		{'Crème fraîche': 'laktose'},
		'Salz',
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/hirschragout.js